const languages = {
  en: { nativeName: "English" },
  hi: { nativeName: "हिन्दी" }
};

export default languages;
